import React from 'react'
import { connect, actions } from 'scripts/store'
import { dispatcher } from 'scripts/components/navigations/NavigationDispatcher'
import Constants from 'scripts/base/Constants'
import locale from 'shared/i18n/react'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.checkContainer = React.createRef()
    this.state = {agree: false}
    dispatcher.on(Constants.Navigations.TOGGLE_NAV_CLASS, this.update)
    this.tickboxId = Math.random().toString(36).substring(7)
  }

  loginWith = (provider) => {
    if (!this.state.agree) {
      this.checkContainer.current.classList.add('has-error')
      return null
    }
    if (this.props.toggleWithId) {
      this.props.toggleWithId()
    }
    return actions.login(provider)
  }

  componentWillUnmount() {
    dispatcher.off(Constants.Navigations.TOGGLE_NAV_CLASS, this.update)
  }

  update = (data) => {
    if (!data.active) {
      this.checkContainer.current.classList.remove('has-error')
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.auth === 'OK' && nextProps.login)) { // login
      window.location.reload()
    } else if (nextProps.auth === 'Error') {
      console.error('Login Error has occured.')
    }
  }

  handleCheckboxChange = (event) => {
    const target = event.target
    const value = target.checked
    const name = target.name

    this.setState({
      [name]: value
    })

    if (value === true) {
      this.checkContainer.current.classList.remove('has-error')
    }
  }

  render() {
    const lang = locale.getLanguage() || Constants.DefaultLang
    const langPrefix = (lang !== Constants.DefaultLang) ? `${lang}` : ''

    return (
      <div className="dropdown-login-form">
        <div className="section">
          <a href="javascript:;" className="btn btn-unicorn uppercase facebook-login" onClick={() => this.loginWith('facebook')}>{locale.login.facebookPrompt}</a>
          <a href="javascript:;" className="btn btn-unicorn uppercase google-login" onClick={() => this.loginWith('google')}>{locale.login.googlePrompt}</a>
        </div>
        <div className="tickbox-container" ref={this.checkContainer}>
          <input type="checkbox" id={this.tickboxId} name="agree" checked={this.state.agree} onChange={this.handleCheckboxChange} /><label htmlFor={this.tickboxId}></label>{ locale.formatString(locale.login.toc, <a href={`${langPrefix}/terms`} target="_blank">{locale.login.termsOfUseLinkCta}</a>, <a href={`${langPrefix}/privacy`} target="_blank">{locale.login.privacyLinkCta}</a>) }
          <div className="error-message">{locale.login.tocPrompt}</div>
        </div>
      </div>
    )
  }
}

const mapToProps = ({auth, user, login, logout}) => {
  return {auth, user, login, logout}
}

export default connect(mapToProps)(Login)



// WEBPACK FOOTER //
// ./assets/js/lib/firebase/login.jsx